import React from "react"
import { Tooltip } from "@material-ui/core"
import { Info as InfoIcon } from "@material-ui/icons"
import { SECOND_IN_MS } from "@/utils/time"
import useStyles from "@/components/LidContactWarning/styles"

export const LID_CONTACT_WARNING_TEXT = "Este contato ainda não está no novo padrão de identificação do WhatsApp. A atualização acontece automaticamente conforme novas mensagens são recebidas. Assim que a conversão for concluída, este aviso será removido."

const LidContactWarning: React.FC = () => {
	const classes = useStyles()

	return (
		<Tooltip
			title={LID_CONTACT_WARNING_TEXT}
			enterDelay={1 * SECOND_IN_MS}
		>
			<InfoIcon
				className={classes.icon}
			/>
		</Tooltip>
	)
}

export default LidContactWarning
